import { IReferralItem, IVoucher } from '@torim-app/types';
import {adminUrlBuilder} from "@app/api/utils";

export class ReferralApi {

  static readonly path = 'referral';

  static async fetchAllReferrals(): Promise<IReferralItem[]> {
    const url = adminUrlBuilder({}, `${ReferralApi.path}/list`);
    const response = await fetch(url, {
      method: 'get',
      headers: {
        'content-type': 'application/json'
      }
    });
    if (!response.ok)
      throw "Failed to get referrals lits";

    return await response.json();
  }
}
